/** @jsxImportSource @emotion/react */
import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import InputIcon from '@mui/icons-material/Input';
import { Drawer, useMediaQuery, useTheme } from '@mui/material';
import { GtHidden } from '../../../../components/temp-custom-ui-components';
import { appConfig, PRODUCTION_MODE_ENV } from '../../../../constants';
import routesSingletonService from '../../../../routes/routes.service';
import { selectUser } from '../../../../store/reducers';

import { Footer, SidebarNav } from './components';
import { useStyles } from './SideBar.styles';

type SideBarProps = {
  onClose?: () => void;
  onSignOut: () => void;
  open?: boolean;
};

export function SideBar({
  open,
  onClose,
  onSignOut,
}: SideBarProps): React.ReactElement {
  const theme = useTheme();
  const styles = useStyles(theme);
  const user = useSelector(selectUser);

  const isDesktop = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });

  const topPages = useMemo(
    () => routesSingletonService.getAvailableRoutes(user),
    [user],
  );

  const exitBtn = [
    {
      title: 'Sign out',
      icon: <InputIcon />,
      onClick: onSignOut,
    },
  ];

  return (
    <Drawer
      css={styles}
      anchor="left"
      classes={{ paper: 'drawer' }}
      onClose={onClose}
      open={isDesktop || open}
      variant={isDesktop ? 'persistent' : 'temporary'}
    >
      <div className="drawer-container" data-test-id="drawer-container">
        <div className="nav">
          <SidebarNav pages={topPages} onLinkClick={() => onClose()} />

          <GtHidden mdUp>
            <SidebarNav pages={exitBtn} />
          </GtHidden>
        </div>
        {appConfig.env.NODE_ENV !== PRODUCTION_MODE_ENV && <Footer />}
      </div>
    </Drawer>
  );
}
